export default __webpack_public_path__ + "static/media/4-SUMMARY.d373b793.pdf";